module.exports = __webpack_public_path__ + "static/media/avatar.324d1a8a.jpg";